theme.currencyModal = (function () {
  var selectors = {
    disclosureLocale: "[data-disclosure-locale]",
    disclosureCurrency: "[data-disclosure-currency]",
  };

  var modal;

  function init() {
    var container = document.getElementById("CurrencyModal");
    var localeDisclosure = container.querySelector(selectors.disclosureLocale);
    var currencyDisclosure = container.querySelector(
      selectors.disclosureCurrency
    );

    modal = new theme.Modals("CurrencyModal", "currency-modal", {
      closeOffContentClick: false,
    });

    if (currencyDisclosure) {
      this.currencyDisclosure = new theme.Disclosure(currencyDisclosure);
    }

    if (localeDisclosure) {
      this.localeDisclosure = new theme.Disclosure(localeDisclosure);
    }
  }

  return {
    init: init,
  };
})();

theme.Reviews = (function () {
  var defaults = {
    adaptiveHeight: true,
    avoidReflow: true,
    pageDots: true,
    prevNextButtons: false,
    autoplay: false,
  };

  var defaultsDesktop = {
    adaptiveHeight: true,
    contain: true,
    avoidReflow: true,
    pageDots: false,
    prevNextButtons: false,
    groupCells: true,
    wrapAround: false,
  };

  function Reviews(container) {
    this.container = container;
    this.timeout;
    var sectionId = container.getAttribute("data-section-id");
    this.slideshow = container.querySelector("#Reviews-" + sectionId);
    this.namespace = ".review-" + sectionId;

    if (!this.slideshow) {
      return;
    }

    theme.initWhenVisible({
      element: this.container,
      callback: this.init.bind(this),
      threshold: 600,
    });
  }

  Reviews.prototype = Object.assign({}, Reviews.prototype, {
    init: function () {
      if (theme.config.bpSmall) {
        this.flickity = new theme.Slideshow(this.slideshow, defaults);
      } else {
        this.flickity = new theme.Slideshow(this.slideshow, defaultsDesktop);
      }

      if (this.slideshow.dataset.count > 2) {
        this.timeout = setTimeout(
          function () {
            this.flickity.goToSlide(1);
          }.bind(this),
          1000
        );
      }
    },

    onUnload: function () {
      if (this.flickity && typeof this.flickity.destroy === "function") {
        this.flickity.destroy();
      }
    },

    onDeselect: function () {
      if (this.flickity && typeof this.flickity.play === "function") {
        this.flickity.play();
      }
    },

    onBlockSelect: function (evt) {
      var slide = this.slideshow.querySelector(
        ".Reviews-slide--" + evt.detail.blockId
      );
      var index = parseInt(slide.dataset.index);

      clearTimeout(this.timeout);

      if (this.flickity && typeof this.flickity.pause === "function") {
        this.flickity.goToSlide(index);
        this.flickity.pause();
      }
    },

    onBlockDeselect: function () {
      if (this.flickity && typeof this.flickity.play === "function") {
        this.flickity.play();
      }
    },
  });

  return Reviews;
})();

theme.markExternalLinks = (function () {
  var re = new RegExp(location.host);

  function init() {
    var links = document.querySelectorAll("a");
    links.forEach((link) => testLink(link));
  }

  function testLink(link) {
    var linkHref = link.getAttribute("href");
    if (
      !re.test(link.hostname) &&
      linkHref !== "https://www.facebook.com/getocushield/reviews/" &&
      linkHref !== "https://mumsclub.co.uk/ocushield-review/" &&
      link?.dataset?.follow === undefined
    ) {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "nofollow noopener");
    }
  }

  return {
    init: init,
  };
})();

theme.progressShipping = (function () {
  var container = document.getElementById("CartShippingCalculator");
  var successMsg = document.querySelector("#CartShippingCalculator [data-success]");
  var progressMsg = document.querySelector("#CartShippingCalculator [data-progress]");
  var freeNote = document.getElementById("ShippingFreeNote");
  var remainingMsg = document.querySelector("#CartShippingCalculator [data-remaining]");
  if (document.getElementById("CartShippingBar")) {
    var progress = bar("CartShippingBar");
    progress.set(document.getElementById("CartShippingBar").dataset.percent);
  }
  var percent = 0;
  var restTemplate;
  var isSuccess = false;

  function init() {
    var target = parseInt(container.dataset.target);
    if (Number.isNaN(target) || !target) {
      return;
    }

    document.addEventListener("ajaxProduct:added", async function () {
      var total = await getCartTotal();
      calculateSavings(total, target);
      renderMsg();
    });

    document.addEventListener("cart:updated", function (evt) {
      var total = evt.detail.cart.total_price;
      calculateSavings(total, target);
      renderMsg();
    });
  }

  function calculateSavings(total, target) {
    var result = target - total;
    if (result <= 0) {
      percent = 100;
      isSuccess = true;
      restTemplate = "";
    } else {
      percent = (total / target) * 100;
      isSuccess = false;
      restTemplate = theme.Currency.formatMoney(
        result,
        theme.settings.moneyFormat
      );
    }
  }

  function renderMsg() {
    progress.set(percent);
    if (isSuccess) {
      successMsg.style.display = "block";
      progressMsg.style.display = "none";
      freeNote.style.display = "flex";
      return;
    }
    successMsg.style.display = "none";
    progressMsg.style.display = "block";
    freeNote.style.display = "none";
    remainingMsg.innerHTML = restTemplate;
  }

  async function getCartTotal() {
    try {
      var response = await fetch("/cart.js");
      var cart = await response.json();
      return cart.total_price;
    } catch (err) {
      throw new Error(err);
    }
  }

  return {
    init: init,
  };
})();

function bar(wrap, indicate) {
  wrap = document.getElementById(wrap);
  wrap.classList.add("progress");

  var bar = document.createElement("div");
  bar.classList.add("bar");
  wrap.appendChild(bar);

  var indicator = null;
  if (indicate) {
    indicator = document.createElement("div");
    indicator.classList.add("indicator");
    indicator.innerHTML = "0%";
    wrap.appendChild(indicator);
  }

  return {
    wrap: wrap,
    bar: bar,
    indicator: indicator,
    set: function (percent) {
      this.bar.style.width = percent + "%";
      if (this.indicator) {
        this.indicator.innerHTML = percent + "%";
      }
    },
  };
}

theme.pressSlider = (function () {
  function init() {
    var slider = document.getElementById("PressSlider");
    var nav = document.getElementById("PressSliderNav");
    if (!slider || !nav) return;
    var args = {
      asNavFor: "#PressSlider",
      contain: true,
      pageDots: false,
      prevNextButtons: false,
    };
    const sliderInstance = new Flickity(slider, {
      autoPlay: 2500,
      adaptiveHeight: false,
    });
    new Flickity(nav, args);
    nav.addEventListener("mouseover", () => {
      sliderInstance.pausePlayer();
    });
    nav.addEventListener("mouseout", () => {
      sliderInstance.playPlayer();
    });
  }

  return {
    init: init,
  };
})();

theme.Upsell = (function () {
  var container = document.querySelector(".upsell-product");
  var upsellForm = document.getElementById("AddToCartForm-Upsell");
  var upsellProductId = container ? container.dataset.productId : null;

  function init() {
    if (!upsellProductId) {
      return;
    }

    if (theme.settings.cartType === "drawer") {
      new theme.AjaxProduct(upsellForm);
    }

    document.addEventListener("ajaxProduct:added", function (e) {
      if (e.detail.product.product_id == upsellProductId) {
        toggleUpsell(false);
      } else {
        toggleUpsell(true);
      }
    });

    document.addEventListener("cart:updated", function (e) {
      if (!e.detail.cart.items.length) {
        toggleUpsell(false);
        return;
      }
      var isUpsellInTheCart = e.detail.cart.items.some(
        (element) => element.product_id == upsellProductId
      );
      toggleUpsell(!isUpsellInTheCart);
    });

    bindImageChanging();
  }

  function toggleUpsell(show) {
    if (show) {
      container.style.display = "flex";
    } else {
      container.style.display = "none";
    }
  }

  function bindImageChanging() {
    var radios = container.querySelectorAll('input[type=radio][name="id"]');
    var image = document.getElementById("UpsellImg");
    var selectedRadioImage = container.querySelector(
      'input[type=radio][name="id"]:checked'
    ).dataset.variantImg;
    if (selectedRadioImage && selectedRadioImage.length) {
      image.src = selectedRadioImage;
    }

    radios.forEach((radio) =>
      radio.addEventListener("change", (e) => {
        var newImgUrl = e.currentTarget.dataset.variantImg;
        if (newImgUrl && newImgUrl.length) {
          image.src = newImgUrl;
        }
      })
    );
  }

  return {
    init: init,
  };
})();

theme.ExcerptWidget = {
  addClass: function (element, theClass) {
    element.classList.add(theClass);
  },

  removeClass: function (element, theClass) {
    element.classList.remove(theClass);
  },

  showMore: function (element, excerpt) {
    element.addEventListener("click", (event) => {
      var linkText = event.target.textContent.toLowerCase();
      event.preventDefault();

      if (linkText == "show more") {
        element.textContent = "Show less";
        this.removeClass(excerpt, "excerpt-hidden");
        this.addClass(excerpt, "excerpt-visible");
      } else {
        element.textContent = "Show more";
        this.removeClass(excerpt, "excerpt-visible");
        this.addClass(excerpt, "excerpt-hidden");
      }
    });
  },

  init: function (showMoreLinksTarget, excerptTarget) {
    var showMoreLinks = document.querySelectorAll(showMoreLinksTarget);
    var $this = this;

    showMoreLinks.forEach(function (link) {
      var excerpt = link.previousElementSibling.querySelector(excerptTarget);
      $this.showMore(link, excerpt);
    });
  },
};

theme.sizeGuideModal = (function () {
  var modal;

  function init() {
    modal = new theme.Modals("SizeGuideModal", "sizeguide-modal");
  }

  return {
    init: init,
  };
})();

theme.measureModals = (function () {
  var measurePdModal;
  var measureHeightModal;

  function init() {
    measurePdModal = new theme.Modals("MeasurePDModal", "measurepd-modal");
    measureHeightModal = new theme.Modals(
      "measureHeightModal",
      "measureheight-modal"
    );
    console.log(measurePdModal, measureHeightModal);
  }

  return {
    init: init,
  };
})();

document.addEventListener("DOMContentLoaded", function () {
  theme.sections.register("reviews", theme.Reviews);
  theme.currencyModal.init();
  theme.markExternalLinks.init();
  theme.pressSlider.init();
  if (document.getElementById("CartShippingCalculator")) {
    theme.progressShipping.init();
  }
  theme.Upsell.init();
  theme.ExcerptWidget.init(".js-show-more", ".js-excerpt");
  theme.sizeGuideModal.init();
});
